'use strict';

const { setWishlistIconInList } = require('../product/wishlistHeart');
const csrf = require('cisalfa/csrf/csrf');

async function checkWishlistListInStorage() {
    if (document.querySelectorAll("div.product.cc-product").length) {
        var csrf_token = await csrf.methods.getCsrfToken();
        if (wishlistGetListUrl && csrf_token) {
            $.ajax({
                url: wishlistGetListUrl,
                type: 'post',
                dataType: 'json',
                data: { csrf_token: csrf_token.token },
                success: function (data) {
                    sessionStorage.setItem('wishlistList', data.wishlistList);
                    sessionStorage.setItem('originalWishlistList', data.originalWishlistList);
                    setWishlistIconInList(true);
                }
            });
        } else {
            setWishlistIconInList(true);
        }
    }
}

checkWishlistListInStorage();